module.exports = __webpack_public_path__ + "media/hallBgm.8a2cdf2d.mp3";